import type { User } from '../user/types'

export type UserDisplayData = {
  fullName: string
  email: string
}

export function getUserDisplayData(user: User | null | undefined): UserDisplayData {
  const profileName = user?.profile?.name || user?.profile?.nickname || ''
  const fullName =
    [user?.regionalData?.firstname, user?.regionalData?.lastname].filter(Boolean).join(' ') || profileName || 'User'

  const email = user?.regionalData?.email || user?.profile?.email || ''

  return {
    fullName,
    email,
  }
}
